import React from 'react';
import PropTypes from 'prop-types';

const styles = {
    allText: {
        MozUserSelect: 'text',
        WebkitUserSelect: 'text',
        msUserSelect: 'text',
        userSelect: 'text'
    },
}

export class EllipsisText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ellipsis: true
        };

        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
    }

    hide(e){
        e.preventDefault();
        this.setState({ellipsis: true})
    }

    show(e){
        e.preventDefault();
        this.setState({ellipsis: false})
    }

    render() {
        let {
            text,
            length,
            tail,
            tailClassName,
            ...others
        } = this.props;

        if (text.length <= length ||length < 0 || this.state.ellipsis === false) {
            return <span {...others}>{text}<a onClick={this.hide} style={{textDecoration: 'underline'}}> Show less</a></span>;
        } else {

            const tailStyle = {
                cursor: 'auto'
            };

            let displayText;
            if (length - tail.length <= 0){
                displayText = '';
            } else {
                displayText = text.slice(0, (length - tail.length))
            }

            return (
                <span title={text} {...others}>
                    {displayText}
                    <span style={tailStyle}
                        className={tailClassName}>
                        {tail}
                    </span>
                    <a onClick={this.show} style={{textDecoration: 'underline'}}> Show more</a>
                </span>);
        }
    }
}

EllipsisText.propTypes = {
    text: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
    tail: PropTypes.string,
    tailClassName: PropTypes.string,
};

EllipsisText.defaultProps = {
    tail: '...',
    tailClassName: 'more',
};
